import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Shell } from "./components/layout/Shell";
import { Home } from "./pages/Home";
import { SignIn } from "./pages/SignIn";
import { AllCards } from "./pages/AllCards";
import { CardDetail } from "./pages/CardDetail";
import { CardForm } from "./pages/CardForm";
import { Decks } from "./pages/Decks";
import { DeckEditor } from "./pages/DeckEditor";
import { Playtest } from "./pages/Playtest";
import { PlaytestSolo } from "./pages/PlaytestSolo";
import { PlaytestPassAndPlay } from "./pages/PlaytestPassAndPlay";
import { PlaytestLobby } from "./pages/PlaytestLobby";
import { PlaytestOnline } from "./pages/PlaytestOnline";
import { PlaytestBoard } from "./pages/PlaytestBoard";
import { ReferenceDataPage } from "./pages/ReferenceData";
import { Glossary } from "./pages/Glossary";
import { ImportExport } from "./pages/ImportExport";
import { AdminPanel } from "./pages/AdminPanel";
import { useAuth } from "./hooks/useAuth";

function AdminRoute({ children }: { children: React.ReactNode }) {
  const { loading, profile } = useAuth();
  if (loading) return <p className="p-6 text-sm text-[#64748b]">Loading…</p>;
  if (profile?.role !== "admin") return <Navigate to="/" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Shell />}>
          <Route path="/" element={<Home />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/cards" element={<AllCards />} />
          <Route
            path="/cards/add"
            element={
              <AdminRoute>
                <CardForm />
              </AdminRoute>
            }
          />
          <Route path="/cards/:id" element={<CardDetail />} />
          <Route
            path="/cards/:id/edit"
            element={
              <AdminRoute>
                <CardForm />
              </AdminRoute>
            }
          />
          <Route
            path="/decks"
            element={
              <AdminRoute>
                <Decks />
              </AdminRoute>
            }
          />
          <Route
            path="/decks/new"
            element={
              <AdminRoute>
                <DeckEditor />
              </AdminRoute>
            }
          />
          <Route
            path="/decks/:id/edit"
            element={
              <AdminRoute>
                <DeckEditor />
              </AdminRoute>
            }
          />
          <Route path="/playtest" element={<Playtest />} />
          <Route path="/playtest/solo" element={<PlaytestSolo />} />
          <Route path="/playtest/pass-and-play" element={<PlaytestPassAndPlay />} />
          <Route path="/playtest/lobby/:id" element={<PlaytestLobby />} />
          <Route path="/playtest/online/:id" element={<PlaytestOnline />} />
          <Route path="/playtest/board" element={<PlaytestBoard />} />
          <Route
            path="/reference"
            element={
              <AdminRoute>
                <ReferenceDataPage />
              </AdminRoute>
            }
          />
          <Route path="/glossary" element={<Glossary />} />
          <Route
            path="/import-export"
            element={
              <AdminRoute>
                <ImportExport />
              </AdminRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function NotFound() {
  return (
    <div className="py-20 text-center">
      <h1 className="font-display text-3xl font-bold">404</h1>
      <p className="mt-2 text-[#64748b]">That page is in another arena.</p>
    </div>
  );
}
